import { lazy } from '../../../shared/deployment';

// eslint-disable-next-line import/prefer-default-export
export const JMTRegistraion = lazy(() => import('./JMTRegistraion'));
